define(["require", "exports"], function (require, exports) {
    "use strict";
    exports.__esModule = true;
    var lookup = {};
    exports.loadScript = function (scriptUrl) {
        if (!lookup[scriptUrl]) {
            var $script = $("<script aync defer src='" + scriptUrl + "'></script>");
            $script.appendTo('body');
            lookup[scriptUrl] = true;
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/scriptLoader.js
// module id = 91
// module chunks = 0